import { number, struct } from 'io-ts/Decoder';

export const Page = struct({
	original: number,
	variation: number,
});
